import axios from 'axios';
//import store from '@/store/index';
import { setInterceptors } from '@/api/common/interceptors';
import logInterceptor from 'cgoing-axiosloginterceptors';
function createInstance() {
  const instance = axios.create({
    baseURL: `${process.env.VUE_APP_API_CONTEXT_PATH}`,
  });
  process.env.NODE_ENV === 'development' && logInterceptor(instance);
  return instance;
}
function createInstanceWithAuth() {
  return setInterceptors(createInstance());
}

export const instance = createInstance();

export const authInstance = createInstanceWithAuth();
